import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import { DarkModeToggle } from "../ui";

export function MentionsLegales() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-slate-100 dark:bg-slate-900 text-gray-900 dark:text-white">
      <div className="absolute top-4 right-4 z-20 flex items-center gap-4">
        <DarkModeToggle />
        <Link
          to="/"
          className="flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-200 dark:border-white/10 bg-white dark:bg-slate-800 text-gray-700 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
        >
          <ArrowLeft size={18} />
          {t("legal.back")}
        </Link>
      </div>
      <div className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold mb-8">{t("legal.mentions")}</h1>
        <div className="prose prose-slate dark:prose-invert max-w-none space-y-4 text-gray-600 dark:text-slate-300">
          <p>
            Conformément aux dispositions des articles 6-III et 19 de la Loi n° 2004-575 du 21 juin 2004
            pour la Confiance dans l&apos;économie numérique, dite L.C.E.N., les présentes mentions légales
            s&apos;appliquent au service Régie Connect.
          </p>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Éditeur du site</h2>
          <p>
            [À compléter : dénomination sociale ou nom, adresse du siège, numéro SIRET, contact.]
          </p>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Hébergement</h2>
          <p>
            [À compléter : nom et adresse de l&apos;hébergeur.]
          </p>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-8">Propriété intellectuelle</h2>
          <p>
            L&apos;ensemble du contenu de ce service est protégé par le droit d&apos;auteur et les marques.
            Toute reproduction non autorisée est interdite.
          </p>
        </div>
      </div>
    </div>
  );
}
